import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentSection } from "@cinch-labs/design-system";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { CookiePolicyTable } from "../cookie-policy-table/cookie-policy-table";
export var TableSection = function(param) {
    var heading = param.heading, description = param.description, table = param.table, dontShowTableHeader = param.dontShowTableHeader;
    return /*#__PURE__*/ _jsxs(ContentSection, {
        children: [
            /*#__PURE__*/ _jsx("p", {
                children: /*#__PURE__*/ _jsx("strong", {
                    children: heading
                })
            }),
            description && renderWithResolver(description),
            table && /*#__PURE__*/ _jsx(CookiePolicyTable, {
                table: table,
                dontShowTableHeader: dontShowTableHeader
            })
        ]
    });
};
